import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFeeds as getFeedsData, getFeedInfo as getFeedInfoData, postFolder,
  postFeedMoveToFolder, postFeedPreview, postFeed, putFeed, deleteFeed,
  postDuplicateFeed, getPreviewWithoutAuth as getPreviewWithoutAuthData,
  getFeedsCampaignsData
} from "../../helpers/backend_helper";
import {
  getFeedErr, getFeedSuccess, getFeedInfoSuccess, setPreview,
  setSourceDataFields, setFieldPathName, setSourceData, setMappedSource,
  setPostFeedBody, setSelectedPath, setIsChangesMade,
  setPreviewErr, setPreviewErrMsg,
  setFeedErr,
  setUsingCampaigns,
  setFeedsPage,
  setFeedsHasMore,
  setFeedsFirstLoad,
} from "./reducer";
import { push, replace } from "redux-first-history";
import { resetSelectedItems } from "../folder/reducer";
import { setPreloader } from "../layouts/reducer";
import { mapFeedSource, transformDataToFields } from "./helper";
import { toast } from "react-toastify";
import config from "../../config";
import { checkMaintenance } from "../auth/login/helper";
import { resetModalState } from "../modals/reducer";
const feedUrl = config[config.status].feedUrl;

export const getFeeds = createAsyncThunk("feeds/getFeedsData", async (searchGlobal = false, { dispatch, getState }) => {
  try {
    const { clientPath, brandPath, folderPath } = getState().MenuData;
    const { query, feedsPage } = getState().Feed;
    let folderId = folderPath;
    let hasMore = true;
    let data = [];
    if (folderPath === null || searchGlobal) {
      folderId = 'all';
    }
    if (folderId !== 'all') {
      const response = await getFeedsData({
        brandId: brandPath,
        folderId: folderPath,
        query: query
      });
      data = response.data;
    } else {
      let page = feedsPage;
      while ((data.length * 75) <= window.innerHeight) {
        const response = await getFeedsData({
          brandId: brandPath,
          folderId: folderPath,
          query: query,
          page: page
        });
        page++;
        if (response.data.length === 0) {
          break;
        }
        data.push(...response.data);
      }
      dispatch(setFeedsPage(page));
    }
    if (data.length === 0) {
      hasMore = false;
    }
    dispatch(setFeedsHasMore(hasMore));
    dispatch(resetSelectedItems());
    return data;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
});

export const getFeedsByPage = createAsyncThunk('feeds/getFeedsByPage', async (page, { dispatch, getState }) => {
  try {
    const { clientPath, brandPath, folderPath } = getState().MenuData;
    const { query, feeds, feedsPage } = getState().Feed;

    if (feeds && feeds.length > 0) {
      let folderId = folderPath;
      if (query !== null && folderPath === null) {
        folderId = 'all';
      }
      const response = await getFeedsData({
        brandId: brandPath,
        folderId: folderId,
        query: query,
        page: feedsPage
      });
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
    return [];
  }
});

export const createFeed = (params) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { user } = getState().Login
    const { brandPath, folderPath } = getState().MenuData;
    const body = getState().Feed.postFeedBody;
    const feeds = getState().Feed.feeds;
    const bodyObj = {
      name: body.name,
      type: body.type.value,
      interval: body.interval,
      canBeEmpty: body.canBeEmpty,
      feed: body.feed,
      operations: body.operations,
      source: body.source,
      brandId: brandPath,
      subOf: folderPath,
    }
    const response = await postFeed(bodyObj);
    if (response.status === 'ok') {
      // dispatch(getFeeds());
      const updatedFeeds = [...feeds, {
        ...bodyObj,
        createdDate: Date.now(),
        modifiedDate: Date.now(),
        status: 1,
        _id: response.data.insertedId,
        createdBy: user.data.userId
      }]
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(replace(window.location.href, { feeds: updatedFeeds }));
      dispatch(setPostFeedBody({
        name: "",
        type: "",
        interval: 86400 * 1000,
        canBeEmpty: false,
        feed: [],
        operations: [],
        source: [],
        brandId: "",
        maxAmount: 5,
        subOf: null
      }));
      dispatch(setSelectedPath(null));
      dispatch(setSourceData(null));
      dispatch(setMappedSource([]));
      dispatch(setPreview([]));
      dispatch(setSelectedPath(null));
      dispatch(openFeed(response.data.insertedId, params));
    } else {
      throw response;
    }

  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const openFeed = (id, params) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    dispatch(resetModalState());
    const { locationHook, title } = getState().MenuData;
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    dispatch(setPreloader(true));
    const res = await dispatch(getFeedInfo({ id: id }));
    if (res.payload !== '') {
      // GET FEED PREVIEW
      const previewRes = await dispatch(getPreviewInfo(res.payload));
      // GET FEED SOURCE DATA FIELDS
      const sourceDataFields = await dispatch(loadSource(res.payload.source));
      // SET BREADCRUMB
      const srcPath = `${locationHook.pathname}/${id}/fields`;
      const newBreadcrumbTitle = { name: res.payload.name, src: srcPath };
      let updatedBreadcrumbTitle = [];
      if (title.length === 0) {
        let feedsPath = `/${params.client}/${params.brand}`;
        if (params.market) {
          feedsPath += `/${params.market}`;
        }
        feedsPath += '/feeds';
        updatedBreadcrumbTitle = [{ name: 'Feeds', src: feedsPath }, newBreadcrumbTitle];
      } else {
        updatedBreadcrumbTitle = [...title, newBreadcrumbTitle];
      }
      // GET USAGE CAMPAINGS
      const feedCampaignsRes = await getFeedsCampaignsData({ feedId: id });
      let usingCampaigns = []
      if (feedCampaignsRes.status === 'ok') {
        dispatch(setUsingCampaigns(feedCampaignsRes.data));
        usingCampaigns = feedCampaignsRes.data;
      }
      // PUSH HISTORY
      console.log('sourceDataFields', sourceDataFields);
      dispatch(push(srcPath, {
        feeds: feeds,
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage,
        isLoading: false,
        showLoader: false,
        feedInfo: res.payload,
        title: updatedBreadcrumbTitle,
        preview: previewRes,
        usingCampaigns: usingCampaigns,
        sourceDataFields: sourceDataFields
      }));
      dispatch(setPreloader(false))
    } else {
      dispatch(setPreloader(false))
      throw res;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const removeFeed = (id) => async (dispatch, getState) => {
  try {
    const { title } = getState().MenuData;
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    let response = await deleteFeed({ id: id });
    if (response.status === 'ok') {
      const updatedFeeds = feeds.map(item => {
        if (item._id === id) {
          const foundFeed = feeds.find(dFeed => dFeed._id === id);
          return { ...item, status: foundFeed.status === 0 ? 1 : 0 }
        } else {
          return item;
        }
      });
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(setFeedsFirstLoad(false));
      dispatch(replace(window.location.href, {
        title: title,
        feeds: updatedFeeds,
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage,
      }))
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
}

export const duplicateFeed = (id) => async (dispatch, getState) => {
  try {
    const { title } = getState().MenuData;
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    let response = await postDuplicateFeed({ id: id });
    if (response.status === 'ok') {
      const foundFeed = feeds.find(item => item._id === id);
      if (foundFeed) {
        const updatedFeeds = [
          {
            ...foundFeed,
            name: `${foundFeed.name} - Copy`,
            _id: response.data.insertedId,
            modifiedDate: new Date().getTime(),
            createdDate: new Date().getTime(),  
          },
          ...feeds];
        dispatch(getFeedSuccess(updatedFeeds));
        dispatch(setFeedsFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          feeds: updatedFeeds,
          hasMore: feedsHasMore,
          firstLoad: false,
          feedsPage: feedsPage,
        }));
        return response;
      }
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
}

export const getFeedInfo = createAsyncThunk("data/getFeedInfoData", async ({ id = '', getPreview = true }, { dispatch, getState }) => {
  const { language } = getState().MenuData;
  try {
    const response = await getFeedInfoData(id);
    if (getPreview) {
      // await dispatch(getPreviewInfo(response.data));
      // dispatch(setIsChangesMade(false));
    }
    if (response.status === 'ok') {
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
})

export const getPreviewInfo = (feed) => async (dispatch, getState) => {
  const { language } = getState().MenuData
  try {
    dispatch(setPreview([]));
    let response = await postFeedPreview({
      id: feed._id,
      feed: feed.feed,
      operations: feed.operations,
      source: feed.source
    });
    if (response.status === 'ok') {
      dispatch(setPreview(response.data));
      dispatch(setIsChangesMade(false));
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error('Something went wrong', { autoClose: 3000 });
    dispatch(setPreview([]));
  }
};

export const updateFeed = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const feedInfo = getState().Feed.feedInfo;
    let response = await putFeed({
      ...feedInfo,
      id: feedInfo._id
    });
    if (response.status === 'ok') {
      toast.success(language[response.code], { autoClose: 3000 });
      await dispatch(getPreviewInfo(feedInfo));
      await dispatch(loadSource(feedInfo.source));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const updateFeedName = (item) => async (dispatch, getState) => {
  try {
    const title = getState().MenuData.title;
    const { 
      feeds,
      feedsHasMore,
      feedsPage 
    } = getState().Feed;
    let response = await putFeed({
      ...item,
      id: item._id
    });
    if (response.status === 'ok') {
      // const feeds = await dispatch(getFeeds());
      const updatedFeeds = feeds.map(feed => {
        if (feed._id === item._id) {
          return {
            ...feed,
            name: item.name
          }
        } else {
          return feed;
        }
      })
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(setFeedsFirstLoad(false));
      dispatch(replace(window.location.href, { 
        title: title,
        feeds: updatedFeeds, 
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage,
      }));
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
}

export const feedMoveToFolder = (id, folderId) => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const { feeds, feedsHasMore, feedsFirstLoad, feedsPage } = getState().Feed;
    const response = await postFeedMoveToFolder({ id: id, folderId: folderId });
    if (response.status !== 'ok') {
      throw response;
    } else {
      const updatedFeeds = feeds.filter(feed => feed._id !== id);
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(setFeedsFirstLoad(false));
      dispatch(replace(window.location.href, {
        title: title,
        feeds: updatedFeeds,
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage,
      }));
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};

export const getSource = (sourceUrl) => async (dispatch, getState) => {
  try {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", sourceUrl);
      xhr.send();

      xhr.addEventListener("readystatechange", async function () {
        if (this.readyState === 4) {
          let data;
          const contentType = this.getResponseHeader("Content-Type");
          if (contentType && contentType.includes("application/json")) {
            data = await JSON.parse(this.responseText);
          } else if (contentType && contentType.includes("application/xml")) {
            data = await this.responseText;
          } else {
            reject();
          }
          resolve(data);
        }
      });
    });
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
};

export const loadSource = (sourceUrl) => async (dispatch, getState) => {
  try {
    const { feedInfo } = getState().Feed;
    const response = await dispatch(getSource(sourceUrl));
    if (response) {
      dispatch(setSourceData(response));
      const map = await mapFeedSource(response);      
      dispatch(setMappedSource(map));
      const fields = dispatch(getFields());
      return fields;
    } else {
      throw '';
    }

  } catch (error) {
    checkMaintenance(dispatch, error);
    dispatch(setFeedErr({ feedErr: true, feedErrMsg: 'Something went wrong when loading the source.' }));
    return false;
  }
}

export const getFields = () => async (dispatch, getState) => {
  try {
    const { sourceData, mappedSource } = getState().Feed;
    let fields = transformDataToFields(sourceData, mappedSource);
    dispatch(setSourceDataFields(fields));
    return fields;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const getPreviewWithoutAuth = (id) => async (dispatch, getState) => {
  try {
    const res = await fetch(`${feedUrl}${id}`);
    const data = await res.json();
    if (data) {
      dispatch(setPreview(data));
      return data;
    } else {
      return null;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const getFeedName = (id) => async (dispatch, getState) => {
  try {
    const res = await getFeedInfoData(id);
    if (res.status === 'ok') {
      return res.data.name;
    } else {
      return null;
    }
  } catch (error) {
    // console.log(error);
    return null;
  }
}